<template>
<div id="avatamsaka">
  <div class="sectionIntroTop">
    <div class="introCover">
      <img src="@/../static/image/content/historyPageTopArea.png" alt="">
    </div>
    <p class="introText" v-html="$t('avatamsaka.history.area01content')">
    </p>
  </div>
  <div class="sectionIntro">
    <div class="sectionBack"></div>
    <div class="sectionBack02"></div>
  </div>

  <div class="itemsBlocks">
    <h2>{{$t('avatamsaka.avatamsaka.title')}}</h2>
    <div class="itemBlock">
      <img src="@/../static/image/content/historyPageStory.jpg" />
      <p v-html="$t('avatamsaka.avatamsaka.content')"></p>

      <hr/>

      <div class="refArea">
        <h2 v-html="$t('avatamsaka.reference.title')">
        </h2>
        <p>
          {{$t('avatamsaka.reference.pageName', {
            'noticeType': $t(`avatamsaka.reference.avatamsaka[0].text`)
          })}}
        </p>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'history',
  data() {
    return {
    };
  },
  methods: {
    getVersionPath(versionId) {
      this.$router.push({
        name: 'version',
        params: {
          vid: versionId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

#avatamsaka {

  .sectionIntroTop {

    .introCover {
      position: relative;
      background: #d9e2c4;
      text-align: left;
      float: left;
      width: 100%;
      padding-bottom: 4.2em;
      img {
        max-height: 500px;
        max-width: 100%;
        margin: 0px;
      }
    }

    .introText {
      color: #ffffff;
      position: absolute;
      background: rgba(21, 22, 23, 0.68);
      width: 50%;
      padding: 40px;
      padding-top: 20px;
      right: 0;
      top: 250px;
    }
    clear: both;
  }

  .sectionIntro {
      clear: both;
      display: flex;
      padding-bottom: 50px;
      position: relative;
    .sectionBack {
      width: 50%;
      height: 0px;
      position: absolute;
      background: #d9e2c4;
      padding-top: 5px;
      right: 0;
    }

    .sectionBack::after {
        border-top: 20vh solid #d9e2c4;
        border-right: 50vw solid transparent;
        content: "";
        top: 100%;
        right: 0;
        position: absolute;
    }

    .sectionBack02 {
      width: 50%;
      height: 0px;
      background: #d9e2c4;
      position: absolute;
      padding-top: 5px;
    }

    .sectionBack02::after {
        border-top: 20vh solid #d9e2c4;
        border-left: 50vw solid transparent;
        content: "";
        top: 100%;
        left: 0;
        position: absolute;
    }

    @media (max-width: 768px) {

        display: block;
        flex-direction: row;

        .introCover, .introContent {
          clear: both;
          display: block;
          width: 100%;
          flex: none;
          margin: 0px;
          padding: 40px;
        }

        .introCover {
          position: relative;
          margin: 0;
          img {
            width: 100%;
          }
        }
    }
  }


  .itemsBlocks{
    text-align: left;
    margin: 0px;
    position: relative;
    h2 {
      position: sticky;
      margin: 0.8em auto;
      padding-left: 100px;
      padding-right: 100px;
    }
    .itemBlock {
      position: sticky;
      padding-left: 100px;
      padding-right: 100px;
      padding-bottom: 100px;
      height: 100%;
      overflow: hidden;
      img {
        max-width: 600px;
        max-height: 100%;
        padding-left: 40px;
        overflow: hidden;
        position: relative;
        float: right;
        clear: right;
      }
      hr {
        margin: 5em 0px;
      }
      .refArea {
        h2 {
          margin-top: 1em;
          padding: 0px;
          margin: 0px;
        }
      }
    }

    .sectionBack {
      bottom: 0px;
      width: 100%;
      height: 20%;
      min-height: 20px;
      background: red;
      position: absolute;
    }

  }

  @media (max-width: 768px) {
    .sectionIntroTop {

      position: relative;

      .introCover {
        z-index: 1;
        display: block;
      }

      .introText {
        display: block;
        background: #d9e2c4;
        position: relative;
        width: 100%;
        color: #194b49;
        padding-bottom: 0px;
        margin: 0px;
        top: 0;
      }
      .sectionBack02 {
        position: relative;
      }
    }

    .itemsBlocks {

      padding: 0px 1em;

      h2 {
        text-align: center;
        padding: 0px;
      }

      .itemBlock {
        margin: 0;
        padding: 0;
        img {
          max-width: 100%;
          max-height: auto;
          padding: 0;
        }
      }

      .sectionBack {
        left: 0;
        bottom: 0px;
        width: 100%;
        height: 10%;
        min-height: 20px;
        background: transparent;
        position: absolute;
        border-bottom: 2em solid #d9e2c4;
      }

      .sectionBack::before {
          border-top: 10vh solid transparent;
          border-right: 50vw solid #d9e2c4;
          content: "";
          bottom: 0;
          left: 0;
          position: absolute;
      }

      .sectionBack::after {
          border-top: 10vh solid transparent;
          border-left: 50vw solid #d9e2c4;
          content: "";
          bottom: 0;
          right: 0;
          position: absolute;
      }


    }

  }

}
</style>



// WEBPACK FOOTER //
// src/components/Avatamsaka.vue